
var x
clearInterval(x);
function countdown(expire) {
    const second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24;
  
    if(typeof expire !== 'undefined' && expire != '' && new Date(expire).getTime()) {

        var countDown = new Date(expire).getTime()

            x = window.setInterval(function() {    
                 
            var now = new Date().getTime(),
                distance = countDown - now;

    
            document.getElementsByClassName('days')[0].innerText = Math.floor(distance / (day)),
            document.getElementsByClassName('hours')[0].innerText = Math.floor((distance % (day)) / (hour)),
            document.getElementsByClassName('minutes')[0].innerText = Math.floor((distance % (hour)) / (minute)),
            document.getElementsByClassName('seconds')[0].innerText = Math.floor((distance % (minute)) / second);
    
            //do something later when date is reached
            if (distance < 0) {
                let headline = document.getElementsByClassName("countdown-message")[0],
                    countdown = document.getElementsByClassName("countdown-container")[0];
                    
                headline.style.display = "block";
                countdown.style.display = "none";
    
                window.clearInterval(x);
            }
            //seconds
            }, 0)
    } else {

        let headline = document.getElementsByClassName("countdown-message")[0],
            countdown = document.getElementsByClassName("countdown-container")[0];

        headline.style.display = "block";
        countdown.style.display = "none";
    }
}